// extracted by mini-css-extract-plugin
export default {"root":"BlockReviewItem_root__3hlms","header":"BlockReviewItem_header__wBlCA","media":"BlockReviewItem_media__SC5ls","text":"BlockReviewItem_text__hoF1b"};